'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LogFile = undefined;

var _bluebird = require('bluebird');

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LogProvider2 = require('./LogProvider.js');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogFile = exports.LogFile = function (_LogProvider) {
	_inherits(LogFile, _LogProvider);

	function LogFile(content, limit) {
		_classCallCheck(this, LogFile);

		var _this = _possibleConstructorReturn(this, (LogFile.__proto__ || Object.getPrototypeOf(LogFile)).call(this, limit));

		_this.content = content;
		_this.lines = _this.content.split('\n');
		return _this;
	}

	_createClass(LogFile, [{
		key: 'loadEntries',
		value: function () {
			var _ref = (0, _bluebird.coroutine)(regeneratorRuntime.mark(function _callee(offset) {
				var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
				var start, end, entries;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								start = this.lines.length - offset;
								end = Math.max(start - count - 2, 0);
								entries = this.lines.slice(end, start).reverse().map(this.tryParseJSON);
								return _context.abrupt('return', { data: entries });

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function loadEntries(_x, _x2) {
				return _ref.apply(this, arguments);
			}

			return loadEntries;
		}()
	}, {
		key: 'tryParseJSON',
		value: function tryParseJSON(json) {
			try {
				return JSON.parse(json);
			} catch (e) {
				// fix unescaped message json
				var startPos = json.indexOf('"message":"') + '"message":"'.length;
				var endPos = json.lastIndexOf('","level":');
				var start = json.substr(0, startPos);
				var end = json.substr(endPos);
				var message = json.substr(startPos, endPos - startPos);

				var escapedMessage = message.replace(/([^\\]|^)["]/g, '$1\\"');
				json = start + escapedMessage + end;

				try {
					return JSON.parse(json);
				} catch (e) {
					console.log('Error while parsing log message:');
					console.log(json);
					console.error(e);
				}
			}
		}
	}]);

	return LogFile;
}(_LogProvider2.LogProvider);


//////////////////
// WEBPACK FOOTER
// ./js/Providers/LogFile.js
// module id = 659
// module chunks = 0